/* facets-always-open.js
   PC 幅のとき .facets-container 内の details を常時 open にするスクリプト
   ※ Shopify 標準 global.js のハンドラとは独立して動作
   ※ モバイルの新しいフィルターUIも制御
*/
(() => {
    /* ブレークポイントを 1025px と定義（テーマの large-up 相当） */
    const MQ_DESKTOP = window.matchMedia('(min-width: 751px)');
  
    /* メイン処理：PC 幅だけ details を開き、スマホでは閉じておく */
    function toggleDetailsOpen() {
      document
        .querySelectorAll('.facets-container details')
        .forEach((detail) => {
          const summary = detail.querySelector('summary');
          if (!summary) return;

          if (MQ_DESKTOP.matches) {
            /* PC では常に開いた状態に固定 */
            detail.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');

            /* 2 回以上 addEventListener しないようにガード */
            if (!summary.dataset.alwaysOpenBound) {
              const handler = (e) => {
                /* 標準の toggle を無効化 */
                e.preventDefault();
                e.stopImmediatePropagation(); // global.js の click ハンドラも止める
              };
              summary.addEventListener('click', handler, true /* capture フェーズで先に止める */);
              summary.dataset.alwaysOpenBound = '1';
            }
          } else {
            /* スマホ幅では開かないようにし、aria 属性も戻す */
            detail.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
        });
    }
  
    /* DOM が組み上がったら一度実行 */
    document.addEventListener('DOMContentLoaded', toggleDetailsOpen);
  
    /* 画面幅が変わったら再評価 */
    MQ_DESKTOP.addEventListener('change', toggleDetailsOpen);

    /* ========== 新しいモバイルフィルターUI制御 ========== */
    document.addEventListener('DOMContentLoaded', () => {
      // モバイル幅（750px以下）の判定
      const MQ_MOBILE = window.matchMedia('(max-width: 750px)');
      
      if (!MQ_MOBILE.matches) return; // PC幅では実行しない

      const overlay = document.querySelector('[data-facets-overlay]');
      const filterButton = document.querySelector('[data-facets-open="filter"]');
      const sortButton = document.querySelector('[data-facets-open="sort"]');
      const filterDrawer = document.querySelector('[data-facets-drawer="filter"]');
      const sortDrawer = document.querySelector('[data-facets-drawer="sort"]');
      const closeButtons = document.querySelectorAll('[data-facets-close]');
      const applyButton = document.querySelector('[data-facets-apply]');
      const sortOptions = document.querySelectorAll('[data-facets-sort-option]');

      // フォーム送信時にURLパラメータをマージする処理
      const mergeUrlParams = (formData, options = {}) => {
        // 現在のURLパラメータを取得
        const currentParams = new URLSearchParams(window.location.search);
        
        // マージ用のパラメータオブジェクト
        const mergedParams = new URLSearchParams();
        
        // オプションのデフォルト値
        const { isFilterOperation = false } = options;
        
        // 現在のパラメータをコピー
        for (const [key, value] of currentParams) {
          let shouldKeep = true;
          
          // ページネーション関連のパラメータは常に除外
          if (key.startsWith('page')) {
            shouldKeep = false;
          }
          // フィルター操作の場合のみ、フィルターパラメータを除外（完全置換のため）
          else if (isFilterOperation && key.startsWith('filter.')) {
            shouldKeep = false;
          }
          
          if (shouldKeep) {
            mergedParams.append(key, value);
          }
        }
        
        // 新しいフォームデータを追加（複数値対応）
        for (const [key, value] of formData.entries()) {
          if (value && value.trim() !== '') { // 空でない値のみ設定
            // console.log('Adding param:', key, '=', value); // デバッグ用（本番では非表示）
            
            // sort_byパラメータの場合は既存のものを削除してから追加
            if (key === 'sort_by') {
              mergedParams.delete(key);
            }
            
            mergedParams.append(key, value);
          }
        }
        
        // console.log('Final URL params:', mergedParams.toString()); // デバッグ用（本番では非表示）
        return mergedParams;
      };

      // ドロワーを開く処理
      function openDrawer(drawer) {
        if (!drawer || !overlay) return;
        
        drawer.classList.add('active');
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden'; // スクロール無効化
      }

      // ドロワーを閉じる処理
      function closeDrawer() {
        const activeDrawer = document.querySelector('.mobile-facets-drawer.active');
        
        if (activeDrawer) {
          activeDrawer.classList.remove('active');
        }
        if (overlay) {
          overlay.classList.remove('active');
        }
        document.body.style.overflow = ''; // スクロール復活
      }

      // フィルターボタンクリック
      if (filterButton && filterDrawer) {
        filterButton.addEventListener('click', () => {
          openDrawer(filterDrawer);
        });
      }

      // 並べ替えボタンクリック
      if (sortButton && sortDrawer) {
        sortButton.addEventListener('click', () => {
          openDrawer(sortDrawer);
        });
      }

      // 閉じるボタンクリック
      closeButtons.forEach(button => {
        button.addEventListener('click', closeDrawer);
      });

      // オーバーレイクリック（単純にドロワーを閉じるのみ）
      if (overlay) {
        overlay.addEventListener('click', () => {
          // オーバーレイクリック時は単純に閉じるだけ（自動送信を無効化）
          closeDrawer();
        });
      }

      // 適用ボタンクリック（フィルター用）
      if (applyButton) {
        applyButton.addEventListener('click', () => {
          // フォームを手動で送信（フィルター操作として処理）
          const form = applyButton.closest('form');
          if (form) {
            const formData = new FormData(form);
            const mergedParams = mergeUrlParams(formData, { isFilterOperation: true });
            const url = `${window.location.pathname}?${mergedParams}`;
            window.location.href = url;
          }
          closeDrawer();
        });
      }

      // 並べ替えオプション選択時の自動送信
      sortOptions.forEach(option => {
        option.addEventListener('change', (e) => {
          if (e.target.checked) {
            // フォームを手動で送信（mergeUrlParamsを使用）
            const form = e.target.closest('form');
            if (form) {
              const formData = new FormData(form);
              const mergedParams = mergeUrlParams(formData);
              const url = `${window.location.pathname}?${mergedParams}`;
              window.location.href = url;
            }
            closeDrawer();
          }
        });
      });

      // facet-filters-form のカスタム要素を初期化（既存の処理を流用）
      const initFacetForm = () => {
        const facetForms = document.querySelectorAll('facet-filters-form');
        facetForms.forEach(form => {
          // Shopifyの標準的なfacetフォーム処理に合わせる
          form.addEventListener('submit', (e) => {
            e.preventDefault();
            const formData = new FormData(e.target);
            // フィルターフォームの送信として処理
            const mergedParams = mergeUrlParams(formData, { isFilterOperation: true });
            const url = `${window.location.pathname}?${mergedParams}`;
            
            // ページ遷移
            window.location.href = url;
          });
        });
      };

      // facet-remove のカスタム要素を初期化
      const initFacetRemove = () => {
        const removeButtons = document.querySelectorAll('facet-remove a');
        removeButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            
            // .mobile-facets-drawer__clear-link の特別処理
            if (button.classList.contains('mobile-facets-drawer__clear-link')) {
              clearCurrentDrawerFilters();
              return; // ページ遷移せずに終了
            }
            
            // 他の facet-remove リンクは従来通りページ遷移
            const url = e.currentTarget.href;
            window.location.href = url;
          });
        });
      };

      // 現在のドロワー内のフィルターをクリアする処理
      const clearCurrentDrawerFilters = () => {
        // アクティブなドロワーを取得
        const activeDrawer = document.querySelector('.mobile-facets-drawer.active');
        if (!activeDrawer) return;
        
        // ドロワー内のすべてのチェックボックスを取得
        const checkboxes = activeDrawer.querySelectorAll('.mobile-facets-checkbox input[type="checkbox"]');
        
        checkboxes.forEach(checkbox => {
          const label = checkbox.closest('.mobile-facets-checkbox');
          
          // チェックを外す
          checkbox.checked = false;
          
          // activeクラスを削除
          if (label) {
            label.classList.remove('active');
          }
        });
        
        // 価格範囲入力もクリア
        const priceInputs = activeDrawer.querySelectorAll('.mobile-facets-price input[type="number"]');
        priceInputs.forEach(input => {
          input.value = '';
        });
      };

      // カスタム要素の初期化
      initFacetForm();
      initFacetRemove();

      // チェックボックスの即時反応
      const initCheckboxInteraction = () => {
        const checkboxes = document.querySelectorAll('.mobile-facets-checkbox input[type="checkbox"]');
        
        checkboxes.forEach(checkbox => {
          const label = checkbox.closest('.mobile-facets-checkbox');
          
          // 初期状態の設定（ページ読み込み時のチェック状態に合わせる）
          if (checkbox.checked) {
            label.classList.add('active');
          } else {
            label.classList.remove('active');
          }
          
          checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
              label.classList.add('active');
            } else {
              label.classList.remove('active');
            }
          });
        });
      };

      // ラジオボタンの即時反応（並べ替え用）
      const initRadioInteraction = () => {
        const radios = document.querySelectorAll('.mobile-facets-sort-label input[type="radio"]');
        
        radios.forEach(radio => {
          radio.addEventListener('change', () => {
            // すべてのラベルからactiveクラスを削除
            document.querySelectorAll('.mobile-facets-sort-label').forEach(label => {
              label.classList.remove('active');
            });
            
            // 選択されたラベルにactiveクラスを追加
            if (radio.checked) {
              radio.closest('.mobile-facets-sort-label').classList.add('active');
            }
          });
        });
      };

      // 初期化
      initCheckboxInteraction();
      initRadioInteraction();
      
      // スティッキーボタン機能の初期化（少し遅延）
      setTimeout(() => {
        initStickyButtons();
      }, 100);
    });

    // スティッキーボタン機能（スマホのみ）
    function initStickyButtons() {
      const facetsButtons = document.querySelector('.mobile-facets-buttons');
      // console.log('facetsButtons:', facetsButtons); // デバッグ用（本番では非表示）
      if (!facetsButtons) return;

      // スマホ幅の判定（750px以下）
      const MQ_MOBILE_STICKY = window.matchMedia('(max-width: 750px)');
      let isSticky = false;
      const headerHeight = 78; // ヘッダーの高さ

      function handleScroll() {
        // スマホ幅でない場合は何もしない
        if (!MQ_MOBILE_STICKY.matches) {
          if (isSticky) {
            facetsButtons.classList.remove('mobile-facets-buttons--sticky');
            isSticky = false;
          }
          return;
        }

        const scrollTop = window.scrollY;
        const shouldBeSticky = scrollTop > headerHeight;
        // console.log('scrollTop:', scrollTop, 'shouldBeSticky:', shouldBeSticky); // デバッグ用（本番では非表示）

        if (shouldBeSticky && !isSticky) {
          facetsButtons.classList.add('mobile-facets-buttons--sticky');
          // console.log('Added sticky class'); // デバッグ用（本番では非表示）
          isSticky = true;
        } else if (!shouldBeSticky && isSticky) {
          facetsButtons.classList.remove('mobile-facets-buttons--sticky');
          // console.log('Removed sticky class'); // デバッグ用（本番では非表示）
          isSticky = false;
        }
      }

      // スクロールイベントをリスナーに追加
      window.addEventListener('scroll', handleScroll);
      
      // 画面サイズ変更時にも確認
      MQ_MOBILE_STICKY.addEventListener('change', handleScroll);
      
      // 初回実行
      handleScroll();
    }
  })();